import React from 'react';


function LogoutPage() {

  function onLogout() {
    // app?.props?.apis.apiLogout().then(() => {
    //   app?.props?.apis?.applogout();
    // })
    const resolve = () => {
      console.log('logout btn', "DESTROY_SESSION");
      app?.props?.store("auth", false);
      app?.props?.store("user", false);
      app?.props?.store("persona", "");
      localStorage.clear();
      window.navigate('/open/login')
    }
    resolve();
    // app?.props.apis.apiLogout().then(res => {
    // }).catch((error) => {
    //   resolve();
    //   console.error(error)
    // });
  }
  return (
    <>
      <button className="btn btn-primary btn-sm" onClick={onLogout}>Logout</button>
    </>
  )
}

export default constore(LogoutPage);